var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globalG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20Z",
    fill: "#B32424"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9766 10.9766C11.4037 10.5495 12.0963 10.5495 12.5234 10.9766L20.5 18.9532L28.4766 10.9766C28.9037 10.5495 29.5963 10.5495 30.0234 10.9766C30.4505 11.4037 30.4505 12.0963 30.0234 12.5234L22.0468 20.5L30.0234 28.4766C30.4505 28.9037 30.4505 29.5963 30.0234 30.0234C29.5963 30.4505 28.9037 30.4505 28.4766 30.0234L20.5 22.0468L12.5234 30.0234C12.0963 30.4505 11.4037 30.4505 10.9766 30.0234C10.5495 29.5963 10.5495 28.9037 10.9766 28.4766L18.9532 20.5L10.9766 12.5234C10.5495 12.0963 10.5495 11.4037 10.9766 10.9766Z",
    fill: "#B32424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.224bcbcf90d0b5057162ac54a6ef5a0e.svg";
export { ForwardRef as ReactComponent };